/**
 * @module local storage adapter
 *
 * Encapsulates the concerns of storing data locally within the browser. Hides
 * the concerns of choosing a local storage technology, as well as the
 * implementation details for how the data is sent and received from the store.
 */
import localforage from 'localforage';
import { appName } from '~/config/settings/app.settings';

const localStorage = window.localStorage;

localforage.config({
  name: appName,
  storeName: 'keyvaluepairs',
  // @ts-expect-error TS(2551): Property 'INDEXDDB' does not exist on type 'LocalF... Remove this comment to see the full error message
  driver: [localforage.LOCALSTORAGE, localforage.INDEXDDB, localforage.WEBSQL],
});

const setItem = async (key, value) => localforage.setItem(key, value);

const getItem = async (key) => localforage.getItem(key);

const removeItem = async (key) => localforage.removeItem(key);

/**
 * Only clear the local forage (library) namespace from domain.
 */
const clear = async () => localforage.clear();

/**
 * Completely clear the entire local storage for domain.
 */
const clearStore = async () => localStorage.clear();

export { setItem, getItem, removeItem, clear, clearStore };
